import React from "react";
import Staff from "../../../component/Communication/Staff";

const StaffScreen = () => {
  return (
    <div>
      <Staff />
    </div>
  );
};

export default StaffScreen;
